export const routes = {
  scoutPick: '/scouts-wtr-pick',
  shelfie: '/profile/shelfie',
  shareTester: '/share-tester',
  eoyWrap: '/profile/wrap',
  stats: '/profile/stats',
  statsEdit: '/profile/stats-edit',
  bingo: '/hackweek/bingo',
  bingoCard: '/hackweek/bingo/card',
}
